import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto py-6" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "font-header text-dark-primary text-xl sm:text-2xl mb-2 sm:mb-0 ml-2" }, " Yearly Overview ", -1)
const _hoisted_4 = { class: "hidden sm:block" }
const _hoisted_5 = { class: "block sm:hidden" }
const _hoisted_6 = { class: "grid grid-cols-1 px-2 sm:grid-cols-3 sm:gap-6 sm:px-0" }
const _hoisted_7 = { class: "grid grid-cols-1 px-2 sm:grid-cols-3 sm:gap-6 sm:px-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h2", { class: "text-gray-700 text-lg" }, "Spending Habits 2020", -1)
const _hoisted_9 = { class: "hidden md:block" }
const _hoisted_10 = { class: "block md:hidden" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h2", { class: "text-gray-700 text-lg" }, "Activity", -1)
const _hoisted_12 = { class: "flex flex-col justify-center items-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Alert = _resolveComponent("Alert")
  const _component_Select = _resolveComponent("Select")
  const _component_CardHeader = _resolveComponent("CardHeader")
  const _component_LineChart = _resolveComponent("LineChart")
  const _component_BarChart = _resolveComponent("BarChart")
  const _component_CardContent = _resolveComponent("CardContent")
  const _component_Card = _resolveComponent("Card")
  const _component_SummaryCard = _resolveComponent("SummaryCard")
  const _component_HorizontalBarChart = _resolveComponent("HorizontalBarChart")
  const _component_DonutChart = _resolveComponent("DonutChart")
  const _component_YTDSummary = _resolveComponent("YTDSummary")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.totalUnpaid)
      ? _createVNode(_component_Alert, {
          key: 0,
          type: "warn",
          message: `You have ${_ctx.totalUnpaid} unpaid bills`
        }, null, 8, ["message"])
      : _createCommentVNode("", true),
    _createVNode(_component_Card, { class: "mx-2 sm:mx-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_CardHeader, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_Select, {
                class: "w-40 mr-3",
                value: _ctx.form.year.value,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.year.value = $event)),
                items: _ctx.years
              }, null, 8, ["value", "items"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_CardContent, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_LineChart, {
                labels: _ctx.chartData.labels,
                data: _ctx.chartData.datasets
              }, null, 8, ["labels", "data"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_BarChart, {
                labels: _ctx.chartData.labels,
                data: _ctx.chartData.datasets
              }, null, 8, ["labels", "data"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_SummaryCard, {
        amount: `$${_ctx.totalSaved}`,
        average: `$${_ctx.averageSaved}`,
        color: "text-primary",
        icon: "DollarIcon",
        title: `Total Saved ${_ctx.form.year.value}`
      }, null, 8, ["amount", "average", "title"]),
      _createVNode(_component_SummaryCard, {
        amount: `$${_ctx.totalEarned}`,
        average: `$${_ctx.averageEarned}`,
        color: "text-secondary",
        icon: "TrendUpIcon",
        title: `Total Earned ${_ctx.form.year.value}`
      }, null, 8, ["amount", "average", "title"]),
      _createVNode(_component_SummaryCard, {
        amount: `$${_ctx.totalSpent}`,
        average: `$${_ctx.averageSpent}`,
        color: "text-danger",
        icon: "TrendDownIcon",
        title: `Total Spent ${_ctx.form.year.value}`
      }, null, 8, ["amount", "average", "title"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_Card, { class: "col-span-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_CardHeader, null, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_CardContent, null, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_HorizontalBarChart)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_DonutChart, { data: _ctx.yearlyExpenseData }, null, 8, ["data"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Card, null, {
        default: _withCtx(() => [
          _createVNode(_component_CardHeader, null, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_CardContent, null, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_YTDSummary, {
                  color: "#45ADA8",
                  percentage: _ctx.savedYtd,
                  text: "Saved since the beginning of the year."
                }, null, 8, ["percentage"]),
                _createVNode(_component_YTDSummary, {
                  color: "#C62828",
                  percentage: _ctx.spentYtd,
                  text: "Spent since the beginning of the year."
                }, null, 8, ["percentage"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}